import React, { Component } from 'react';
import { Table, Space, PageHeader } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

class ReportDetail extends Component {

    render() {
        const dataSource = [];
        let table=null;
        let item=null;
        if(this.props.reportDetail){
            this.props.reportDetail.transactionInfos.map(transaction=>{
                let date=moment(transaction.transactionTime);
                let {amount}=transaction;
                date.locale('my');
                item={
                    ...transaction,
                    transactionTime:date.format('lll'),
                    amount:`${amount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
                dataSource.push(item);
            });
        }
        const columns = [
            {
                title: 'Time',
                dataIndex: 'transactionTime',
                key: 'transactionTime',
                align:'center',
            },
            {
                title: 'Amount',
                dataIndex: 'amount',
                key: 'amount',
                align:'right'
            },
            {
                title: 'Description',
                dataIndex: 'description',
                key: 'description',
                align:'center',
            },
           
         
        ];
        if(dataSource.length>0){
            table=<Table key={this.props.reportDetail.reportId} dataSource={dataSource} columns={columns} bordered/>;
        }
        return (
            <>
                <PageHeader
                    className="site-page-header"
                    title={`ReportDetail`}
                />
                {table}
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        reportDetail:state.report.reportDetail
    }
}
export default withRouter(connect(mapStateToProps, null)(ReportDetail));